import { render, staticRenderFns } from "./ListItemsChanged.vue?vue&type=template&id=90188802&scoped=true&"
import script from "./ListItemsChanged.vue?vue&type=script&lang=js&"
export * from "./ListItemsChanged.vue?vue&type=script&lang=js&"
import style0 from "./ListItemsChanged.vue?vue&type=style&index=0&id=90188802&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90188802",
  null
  
)

export default component.exports